export class VideoRecorderHelper {
  constructor(stream) {
    this.stream = stream;
    this.chunks = [];

    // Try different MIME types in order of preference
    const mimeTypes = [
      "video/webm;codecs=h264,opus",
      "video/webm;codecs=vp8,opus",
      "video/webm;codecs=vp9,opus",
      "video/webm",
      "video/mp4",
    ];

    // Find the first supported MIME type
    this.mimeType = mimeTypes.find((type) =>
      MediaRecorder.isTypeSupported(type)
    );

    if (!this.mimeType) {
      throw new Error("No supported video MIME types found on this browser");
    }

    this.recorder = new MediaRecorder(stream, {
      mimeType: this.mimeType,
      videoBitsPerSecond: 2500000, // 2.5 Mbps
    });
    // console.log(`MediaRecorder created with MIME type: ${this.mimeType}`);

    this.recorder.ondataavailable = (e) => {
      if (e.data.size > 0) {
        // console.log("MediaRecorder data available:", e.data.size);
        this.chunks.push(e.data);
      }
    };
    this.recorder.onstop = () => console.log("MediaRecorder stopped");
    this.recorder.onerror = (e) => console.error("MediaRecorder error:", e);
  }

  startRecording() {
    this.chunks = [];

    // Start recording immediately without waiting
    console.log("Starting MediaRecorder");
    this.recorder.start(250);

    // Set up error handler
    this.recorder.onerror = (error) => {
      console.error("MediaRecorder error:", error);
      throw error;
    };

    // Only verify the recorder started
    if (this.recorder.state !== "recording") {
      throw new Error("MediaRecorder failed to start");
    }
  }

  async stopRecording() {
    console.log("Requesting MediaRecorder to stop");
    return new Promise((resolve, reject) => {
      const handleStop = () => {
        console.log("Handling MediaRecorder stop");
        this.recorder.ondataavailable = null;
        this.recorder.onstop = null;

        // Create blob with proper MIME type (MediaRecorder naturally outputs data in chunks as Blob objects
        const blob = new Blob(this.chunks, { type: this.mimeType });

        // Verify the blob
        if (blob.size === 0) {
          reject(new Error("Recording is empty"));
          return;
        }

        resolve(blob);
      };

      // Set up the stop handler
      this.recorder.onstop = handleStop;

      // Stop recording
      if (this.recorder.state !== "inactive") {
        console.log("Stopping MediaRecorder");
        this.recorder.stop();
      } else {
        console.log("MediaRecorder already inactive");
        resolve(new Blob(this.chunks, { type: this.mimeType }));
      }
    });
  }
}
